define('common/customiseUnderscore',['underscore', 'underscore.string'], function(_, underscoreString) {

    _.str = underscoreString;

    _.assign(_, {

        /**
         * Use this to make a function falsy-safe.
         *
         * If the returned function is called with a falsy value the original function
         * will not be called.
         *
         * @param {Function} func
         */
        skipFalsy: function(func) {

            return function() {

                if (!arguments[0]) {
                    return arguments[0];
                }

                return func.apply(this, arguments);

            };

        },

        /**
         * Use this to make a function only falsy.
         *
         * If the returned function is called with a truthy value the original function
         * will not be called.
         *
         * @param {Function} func
         */
        onlyFalsy: function(func) {

            return function() {

                if (arguments[0]) {
                    return arguments[0];
                }

                return func.apply(this, arguments);

            };

        },

        /**
         * Use this to partially apply a constructor with its prototype copied correctly
         * so that instanceof checks on the partially applied function still pass.
         *
         * @see _.partial
         */
        partialConstructor: function(Constructor) {
            var partial = _.partial.apply(_, arguments);
            partial.prototype = Constructor.prototype;
            return partial;
        },

        /**
         * Turn a constructor into a function which constructs it with any args
         *
         * Useful if you want to map to a constructor and still make sure new is called
         *
         * @param {Function} Constructor
         *
         * @return {Function}
         */
        construct: function(Constructor) {

            return function() {

                var Partial = _.partialConstructor.apply(
                    _,
                    [Constructor].concat(
                        Array.prototype.slice.call(arguments)
                    )
                );

                return new Partial();
            };

        },

        /**
         * Use this when you want the value of the previous call to a function.
         *
         * Lifts a single-param function to a two-param function where the second param is
         * the value previously passed to the first.
         *
         * @param {Any} initialPrevious (Optional)
         * @param {Function} func
         *
         * @return {Function}
         */
        withPrevious: function() {
            var previous = arguments.length > 1 ? arguments[0] : null,
                func = arguments.length > 1 ? arguments[1] : arguments[0];

            return function(current) {
                var oldPrevious = previous;
                previous = current;
                return func(current, oldPrevious);
            };
        }

    });

    _.mixin(
        {

            /**
             * Based on http://stackoverflow.com/questions/3285922/objective-c-round-number-to-nearest-50
             *
             * @param {Number} value   Must be positive for the current implementation
             * @param {Number} nearest
             */
            roundToTheNearest: function(value, nearest) {
                return nearest * _.floor(value / nearest + 0.5);
            }

        },
        {
            chain: false
        }
    );

    return _;

});

